import React from 'react';
import imgImage43 from '../../assets/sections/a2f5c508796d52e3e94b00afb7b3a6576288b536.png';
import imgRectangle66 from '../../assets/sections/264882b5a9c99dc7ae730d1d3aa1f911dd91d60c.png';
import imgImage44 from '../../assets/sections/a80ed9b85ecef8b4f169b5b64bd6aa9de7a060b9.png';
import imgThatimA1Copy1 from '../../assets/sections/ef321b5aec92ea24df00224b9d1d09031f122e72.png';
import imgImage42 from '../../assets/sections/47ef9b05a968f2eb02becde6e5e09a440413a8fc.svg';
import imgVector from '../../assets/sections/8e85af30cecd69a3f52727d6eb0b9a9496a8be89.svg';
import imgVector1 from '../../assets/sections/a114ac1575e0303158ba016f7b07b5da56979d66.svg';
import imgEllipse3 from '../../assets/sections/3d751e9f394467450bfcfa6f382e956e533a9f57.svg';


export default function Checkin() {
  return (
    <div className="bg-white relative w-[1921px] h-[1080px]" data-node-id="2007:523">
      {/* Background gradient */}
      <div className="absolute bg-gradient-to-b from-[#00b14f] h-[1080px] left-[-37px] to-[#00474b] top-0 w-[1995px]" data-name="image 7" data-node-id="2007:524" />
      {/* Top wave mask */}
      <div className="absolute contents left-px top-[-1px]" data-node-id="2007:525">
        <div className="absolute flex h-[450px] items-center justify-center left-px top-[-1px] w-[1920px]">
          <div className="-scale-y-100 flex-none">
            <div className="h-[450px] relative w-[1920px]" data-name="image 42" data-node-id="2007:527"
              style={{ maskImage: `url('${imgImage42}')`, WebkitMaskImage: `url('${imgImage42}')`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: '0px 0px', WebkitMaskPosition: '0px 0px', maskSize: '1920px 450px', WebkitMaskSize: '1920px 450px' }}>
              <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgImage43} />
            </div>
          </div>
        </div>
      </div>
      {/* Left content */}
      <div className="absolute content-stretch flex flex-col gap-[24px] items-start left-[134px] top-[363px] w-[1081px]" data-node-id="2007:580">
        <p className="z-10 font-['Alexandria',sans-serif] font-bold leading-[normal] min-w-full relative shrink-0 text-[#f8fdfa] text-[48px] uppercase w-[min-content]" data-node-id="2007:581">
          Check-in nhận ảnh lấy liền miễn phí
        </p>
        <div className="content-stretch flex flex-col gap-[16px] items-start justify-start relative shrink-0 w-[1039px]" data-node-id="2007:582">
          <div className="z-10 content-stretch flex gap-[16px] items-start relative shrink-0 w-full" data-node-id="2007:583">
            <div className="overflow-clip relative shrink-0 size-[32px]" data-name="Bold / Time / Alarm" data-node-id="2007:584">
              <div className="absolute inset-[8.33%_12.5%]" data-node-id="I2007:584">
                <img alt="" className="absolute block max-w-none size-full" src={imgVector} />
              </div>
            </div>
            <p className="z-10 font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#f8fdfa] text-[32px] whitespace-nowrap">
              Thời gian:
            </p>
            <div>
              <p className="z-10 font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#f8fdfa] text-[32px] whitespace-nowrap" data-node-id="2007:585">
                9h- 15h & 19h - 21h<br />
              </p>
              <p className="w-[400px] z-10 font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#f8fdfa] text-[32px] whitespace-nowrap">{`Thứ 6 & Chủ nhật, ngày 10 - 12.04.2026`}
              </p>
            </div>
          </div>
          <div className="z-10 content-stretch flex gap-[16px] items-center relative shrink-0 w-full" data-node-id="2007:586">
            <div className="overflow-clip relative shrink-0 size-[32px]" data-name="Bold / Map & Location / Map Point" data-node-id="2007:587">
              <div className="absolute inset-[8.33%_16.67%]" data-node-id="I2007:587">
                <img alt="" className="absolute block max-w-none size-full" src={imgVector1} />
              </div>
            </div>
            <p className="z-10 font-['Alexandria',sans-serif] font-normal leading-[normal] relative shrink-0 text-[#f8fdfa] text-[32px] whitespace-nowrap" data-node-id="2007:588">
              Địa điểm: Ga Hải Phòng, Quảng trường Nhà hát lớn Hải Phòng
            </p>
          </div>
        </div>
      </div>
      {/* CTA button */}
      <div className="cursor-pointer z-10 absolute bg-[#f8fdfa] content-stretch flex h-[80px] items-center justify-center left-[134px] px-[19px] py-[14px] rounded-[16px] shadow-[0px_24px_84px_0px_rgba(0,255,114,0.3)] top-[630px] w-[245px]" data-name="Discount container" data-node-id="2007:589">
        <p className="font-['Alexandria',sans-serif] font-bold leading-[1.5] relative shrink-0 text-[#012e2a] text-[21px] text-center whitespace-nowrap" data-node-id="2007:590">
          THAM GIA NGAY
        </p>
      </div>
      {/* Ellipse glow */}
      <div className="absolute left-[1158px] size-[1325px] top-[507px]" data-node-id="2007:591">
        <div className="absolute inset-[0_-0.3%_-0.6%_-0.3%]">
          <img alt="" className="block max-w-none size-full" src={imgEllipse3} />
        </div>
      </div>
      {/* Right side images - updated from Figma 2007:523 */}
      <div className="absolute contents left-[1212.88px] top-[114.61px]" data-node-id="2007:592">
        {/* Rectangle frame (behind) */}
        <div className="absolute flex items-center justify-center left-[1240.29px] size-[571.813px] top-[177.49px]">
          <div className="flex-none rotate-[-6.17deg]">
            <div className="relative size-[519.028px]" data-node-id="2007:593">
              <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
                <img alt="" className="absolute max-w-none object-cover size-full" src={imgRectangle66} />
                <div className="absolute bg-[rgba(0,77,70,0.21)] inset-0" />
              </div>
            </div>
          </div>
        </div>
        {/* Main photo (image 43 / person photo) */}
        <div className="absolute flex h-[746.784px] items-center justify-center left-[1212.88px] top-[114.61px] w-[661.857px]">
          <div className="flex-none rotate-[-6.13deg]">
            <div className="h-[687.478px] relative w-[591.775px]" data-name="image 43" data-node-id="2007:594">
              <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <img alt="" className="absolute h-[146.05%] left-[-34.83%] max-w-none top-[-23.02%] w-[169.67%]" src={imgImage44} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Tilted photo frame (thatim) */}
      <div className="absolute flex h-[672.439px] items-center justify-center left-[1230.69px] top-[455px] w-[615.982px]">
        <div className="flex-none rotate-[-15.93deg]">
          <div className="h-[562.273px] relative w-[480.12px]" data-name="thatim A1 copy 1" data-node-id="2007:595">
            <img alt="" className="absolute inset-0 max-w-none object-cover pointer-events-none size-full" src={imgThatimA1Copy1} />
          </div>
        </div>
      </div>
    </div>
  );
}
